import { createSlice } from '@reduxjs/toolkit';
import { getLegacyTiposTransmision } from '../legacy/thunk.js';

export const initialState = {
    legacyTiposTransmision: [],
    loading: false,
    error: {},
};

const legacyTiposTransmisionSlice = createSlice({
    name: 'legacyTiposTransmision',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyTiposTransmision.fulfilled, (state, action) => {
            state.legacyTiposTransmision = action.payload;
            state.loading = true;
        });
        builder.addCase(getLegacyTiposTransmision.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = true;
        });
        builder.addCase(getLegacyTiposTransmision.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyTiposTransmisionSlice.reducer;